import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, of, switchMap, withLatestFrom } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MeasureActions } from '../measure.actions';
import { Store } from '@ngrx/store';
import { selectCurrentSurveyVersionId, selectSurveyFlowLogicTypeQuestionIdobject } from '../measure.selector';
import { FlowItemsService } from '../../services/flow-items.service';
import { displayLogicActions } from '../actions/display-logic.actions';
import { DisplayLogicService } from '../../services/display-logic.service';

@Injectable()
export class DisplayLogicEffects {
  currentMeasureVersionId = this.store.select(selectCurrentSurveyVersionId);
  selectSurveyFlowLogicTypeQuestionIdobject$ = this.store.select(selectSurveyFlowLogicTypeQuestionIdobject);

  /* flow items branch logic */
  addExpressionToBlock = createEffect(() =>
    this.actions$.pipe(
      ofType(displayLogicActions.addExpressionToBlock),
      withLatestFrom(this.currentMeasureVersionId, this.selectSurveyFlowLogicTypeQuestionIdobject$),
      filter(([_, surveyVersionId]) => surveyVersionId !== null && surveyVersionId !== undefined),
      switchMap(([action, surveyVersionId, flowLogicTypeQuestionIdobject]) =>
        this.displayLogicService.addExpressionToBlock(action.blockItemId, action.expressionType, action.index).pipe(
          switchMap((response) => {
            const expressionId = response?.data[0]?.idobject;

            if (!expressionId) {
              console.error('Expression id is not set');
              return of(displayLogicActions.addExpressionToBlockFailure());
            }

            if (!flowLogicTypeQuestionIdobject) {
              console.error('Flow logic type question idobject is not set');
              return of(displayLogicActions.addExpressionToBlockFailure());
            }

            return this.flowItemsService
              .addSubExpressionBranchLogic(expressionId, flowLogicTypeQuestionIdobject, 0)
              .pipe(
                map(() => MeasureActions.getSurveyVersionTree({ surveyVersionId })),
                catchError(() => of(MeasureActions.addExpressionBranchLogicFailure())),
              );
          }),
          catchError(() => of(MeasureActions.addExpressionBranchLogicFailure())),
        ),
      ),
    ),
  );

  /* flow items branch logic - end */

  /* flow items branch logic */
  addExpressionToQuestion = createEffect(() =>
    this.actions$.pipe(
      ofType(displayLogicActions.addExpressionToQuestion),
      withLatestFrom(this.currentMeasureVersionId, this.selectSurveyFlowLogicTypeQuestionIdobject$),
      filter(([_, surveyVersionId]) => surveyVersionId !== null && surveyVersionId !== undefined),
      switchMap(([action, surveyVersionId, flowLogicTypeQuestionIdobject]) =>
        this.displayLogicService
          .addExpressionToQuestion(action.questionItemId, action.expressionType, action.index)
          .pipe(
            switchMap((response) => {
              const expressionId = response?.data[0]?.idobject;

              if (!expressionId) {
                console.error('Expression id is not set');
                return of(displayLogicActions.addExpressionToQuestionFailure());
              }

              if (!flowLogicTypeQuestionIdobject) {
                console.error('Flow logic type question idobject is not set');
                return of(displayLogicActions.addExpressionToQuestionFailure());
              }

              return this.flowItemsService
                .addSubExpressionBranchLogic(expressionId, flowLogicTypeQuestionIdobject, 0)
                .pipe(
                  map(() => MeasureActions.getSurveyVersionTree({ surveyVersionId })),
                  catchError(() => of(MeasureActions.addExpressionBranchLogicFailure())),
                );
            }),
            catchError(() => of(MeasureActions.addExpressionBranchLogicFailure())),
          ),
      ),
    ),
  );

  /* flow items branch logic - end */

  /* flow items branch logic */
  addExpressionToChoice = createEffect(() =>
    this.actions$.pipe(
      ofType(displayLogicActions.addExpressionToChoice),
      withLatestFrom(this.currentMeasureVersionId, this.selectSurveyFlowLogicTypeQuestionIdobject$),
      filter(([_, surveyVersionId]) => surveyVersionId !== null && surveyVersionId !== undefined),
      switchMap(([action, surveyVersionId, flowLogicTypeQuestionIdobject]) =>
        this.displayLogicService.addExpressionToChoice(action.choiceItemId, action.expressionType, action.index).pipe(
          switchMap((response) => {
            const expressionId = response?.data[0]?.idobject;

            if (!expressionId) {
              console.error('Expression id is not set');
              return of(displayLogicActions.addExpressionToChoiceFailure());
            }

            if (!flowLogicTypeQuestionIdobject) {
              console.error('Flow logic type question idobject is not set');
              return of(displayLogicActions.addExpressionToChoiceFailure());
            }

            return this.flowItemsService
              .addSubExpressionBranchLogic(expressionId, flowLogicTypeQuestionIdobject, 0)
              .pipe(
                map(() => MeasureActions.getSurveyVersionTree({ surveyVersionId })),
                catchError(() => of(MeasureActions.addExpressionBranchLogicFailure())),
              );
          }),
          catchError(() => of(MeasureActions.addExpressionBranchLogicFailure())),
        ),
      ),
    ),
  );

  /* flow items branch logic - end */

  constructor(
    private store: Store,
    private actions$: Actions,
    private flowItemsService: FlowItemsService,
    private displayLogicService: DisplayLogicService,
  ) {}
}
